import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";

const ForceLogoutAlertModal = ({ isModalOpened, handleSelectedFunc }) => {
    const { t } = useTranslation();

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "Enter") {
                handleSelectedFunc({ selectedFunc: "FORCE_LOG_OUT" });
            }
        }

        window.addEventListener("keypress", handleKeyPress);

        return () => {
            window.removeEventListener("keypress", handleKeyPress);
        };
    }, [handleSelectedFunc]);

    if (!isModalOpened) {
        return null;
    }

    return (
        <div className="hc-session-alert-overlay" role="presentation">
            <section className="hc-session-alert-panel" role="dialog" aria-modal="true" aria-labelledby="force-logout-alert-title">
                <div className="hc-session-alert-topline">
                    <span className="hc-session-alert-badge">LOGIN</span>
                    <button type="button" className="hc-session-alert-close" onClick={() => handleSelectedFunc({ selectedFunc: "FORCE_LOGOUT_ALERT_TOGGLE" })} aria-label="닫기">
                        <FaTimes />
                    </button>
                </div>
                <div id="force-logout-alert-title" className="hc-session-alert-headline">
                    <span>다른 브라우저에서</span>
                    <span>로그인 중입니다.</span>
                </div>
                <div className="hc-session-alert-copy">
                    <span>강제 로그아웃하고,</span>
                    <span>현재 브라우저에서</span>
                    <span>로그인 하시겠습니까?</span>
                </div>
                <div className="hc-session-alert-actions">
                    <button type="button" className="hc-session-alert-btn hc-session-alert-btn-primary" onClick={() => handleSelectedFunc({ selectedFunc: "FORCE_LOG_OUT" })}>{t("확인", { ns: "common" })}</button>
                    <button type="button" className="hc-session-alert-btn hc-session-alert-btn-secondary" onClick={() => handleSelectedFunc({ selectedFunc: "FORCE_LOGOUT_ALERT_TOGGLE" })}>{t("취소", { ns: "common" })}</button>
                </div>
            </section>
        </div>
    )
}

export default ForceLogoutAlertModal;
